'use client';
// import styles from './404.module.scss';
import { Button, Result } from 'antd';
import Image from 'next/image';
import DownloadImage from 'assets/images/download.png';
import { TbBrandAndroid, TbWorld } from 'react-icons/tb';
import AppLinkComp from 'components/appLink/appLink.index';
import { APPlicationStoreEnum } from 'types';

const DownloadComp: React.FC<{ source?: APPlicationStoreEnum }> = ({ source }) => {
    return (
        <Result
            icon={
                <Image
                    src={DownloadImage}
                    style={{ width: '100%', height: 'auto', objectFit: 'contain', display: 'none' }}
                    alt="download image"
                />
            }
            title={'دانلود اپلیکیشن تیک سبز'}
            className="p-0-i"
            subTitle={`تیک سبز بستری برای ارتباط مستقیم و بدون واسطه بین خریداران با فروشگاه‌ها، عمده‌فروشان و تولیدکنندگان و کسب‌وکارهای حرفه‌ای است.`}
            extra={
                <div className="g-1 center-content" style={{ flexWrap: 'wrap', maxWidth: '500px', margin: '0 auto' }}>
                    {!source?.length || source === APPlicationStoreEnum.cafebazar ? (
                        <Button
                            type="primary"
                            className="flex-1"
                            size="large"
                            icon={<TbBrandAndroid size={24} />}
                            href="https://cafebazaar.ir/app/ir.alooejare.twa"
                            download
                            target="_blank"
                        >
                            دانلود از کافه بازار
                        </Button>
                    ) : null}
                    {process.env.NEXT_PUBLIC_ANDROID_DOWNLOAD_URL?.length && !source?.length ? (
                        <Button
                            type="primary"
                            className="flex-1"
                            size="large"
                            icon={<TbBrandAndroid size={24} />}
                            href={process.env.NEXT_PUBLIC_ANDROID_DOWNLOAD_URL}
                            download
                            target="_blank"
                        >
                            دانلود مستقیم
                        </Button>
                    ) : null}
                    <AppLinkComp href="/">
                        <Button type="primary" className="flex-1" size="large" icon={<TbWorld size={24} />}>
                            استفاده از نسخه وب اپ
                        </Button>
                    </AppLinkComp>
                </div>
            }
        />
    );
};
export default DownloadComp;
